// 100000 -> 100,000₫
export const formatCurrency = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "₫";
};
